var _circle, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#760000",
    fillOpacity: 0.18
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 18,
    height: 14,
    rx: 1.5,
    stroke: "#760000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19V18H16V19H17ZM20.2929 23.7071C20.6834 24.0976 21.3166 24.0976 21.7071 23.7071C22.0976 23.3166 22.0976 22.6834 21.7071 22.2929L20.2929 23.7071ZM18 23V19H16V23H18ZM17 20H21V18H17V20ZM16.2929 19.7071L20.2929 23.7071L21.7071 22.2929L17.7071 18.2929L16.2929 19.7071Z",
    fill: "#760000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25V26H28V25H27ZM23.7071 20.2929C23.3166 19.9024 22.6834 19.9024 22.2929 20.2929C21.9024 20.6834 21.9024 21.3166 22.2929 21.7071L23.7071 20.2929ZM26 21V25H28V21H26ZM27 24H23V26H27V24ZM27.7071 24.2929L23.7071 20.2929L22.2929 21.7071L26.2929 25.7071L27.7071 24.2929Z",
    fill: "#760000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.2b10c623d04d9c77e84960df35c9fb62.svg";
export { ForwardRef as ReactComponent };